import axios from 'axios'
import { errorHandler } from '@/api/error-handler'

export default {
    list: () => axios.get(`/formulations`)
    .then(response => response.data)
    .catch(errorHandler)
}